import { useDispatch } from "react-redux";
import { info } from "../actions";
import { deleteItemAsync } from "../thunks";
export default function Item({ name, imgUrl, _id }) {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteItemAsync(_id));
  };

  const handleInfo = () => {
    dispatch(info(_id));
  };

  return (
    <section className="item">
      <h3>{name}</h3>
      <button onClick={handleInfo}>info</button>
      <button onClick={handleDelete}>delete</button>
      <img src={imgUrl} alt={""} />
    </section>
  );
}
